module.exports = __webpack_public_path__ + "img/check-azul-3.6e9ed850.svg";